import { jsx as i } from "react/jsx-runtime";
import { PointInMap as p } from "./PointInMap.js";
const l = (e) => e.filter((o) => !!o.property.address.location).map((o, d) => {
  var r, t;
  return {
    id: o.id,
    latitude: (r = o.property.address.location) == null ? void 0 : r.latitude,
    longitude: (t = o.property.address.location) == null ? void 0 : t.longitude,
    key: d,
    render: () => /* @__PURE__ */ i(p, { unit: o }),
    to: `/units/${o.id}`
  };
});
export {
  l as getPoints
};
//# sourceMappingURL=utils.js.map
